import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {FileCardList, ButtonGroup, Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$ce(2, 'span', '溢出方式：', 16),
            _$cc(ButtonGroup, {
                'checkType': 'radio',
                'children': [
                    _$cc(Button, {
                        'value': 'scrollX',
                        'children': 'scrollX'
                    }),
                    _$cc(Button, {
                        'value': 'scrollY',
                        'children': 'scrollY'
                    }),
                    _$cc(Button, {
                        'value': 'wrap',
                        'children': 'wrap'
                    })
                ],
                'ev-$model:value': function($v) {
                    $this.set('overflow', $v);
                },
                'value': $this.get('overflow')
            })
        ], 4, 'file-card-demo-list-toolbar'),
        _$ce(2, 'div', [
            _$ce(2, 'div', '各类文件', 16, 'file-card-demo-list-title'),
            _$ce(2, 'div', (
                _$cc(FileCardList, {
                    'items': this.get('fileItems'),
                    'overflow': this.get('overflow'),
                    'deleteable': true,
                    'ev-delete': this.onDeleteFile
                })
            ), 2, 'file-card-content')
        ], 4, 'file-card-demo-list-section'),
        _$ce(2, 'div', [
            _$ce(2, 'div', '图片列表', 16, 'file-card-demo-list-title'),
            _$ce(2, 'div', (
                _$cc(FileCardList, {
                    'items': this.get('imageItems'),
                    'overflow': this.get('overflow'),
                    'ev-delete': this.onDeleteImage,
                    'deleteable': true
                })
            ), 2, 'file-card-content')
        ], 4, 'file-card-demo-list-section')
    ], 4, 'file-card-demo-list');
};